// extracted by mini-css-extract-plugin
export default {"objetsscene":"Room_objetsscene__snbn0","hidden":"Room_hidden__kCR2g","etiquette":"Room_etiquette__LDRev","forward":"Room_forward__qVjWc"};